import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAdminCurrency, addAdminCurrency, updateAdminCurrency, deleteAdminCurrency } from "../../redux/actions/adminCurrency.action";
import { getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getLog } from "../../redux/actions/log.action";
import { getRights } from "../../redux/actions/userRights.action";
import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables";
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider } from "antd";
import { logColumns, adminCurrencyColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";

const { TabPane } = Tabs;

export default function AdminCurrency({ token }) {
  TabTitle("Admin Currency")
  const menuId = ReadCookie("menuId");
  const dCompanyId = ReadCookie("defaultCompany");
  const adminCurrencyNameInput = useRef(null);
  const [form] = Form.useForm();
  const [adminCurrencyObj, setAdminCurrencyObj] = useState(null);
  const dispatch = useDispatch();
  const { adminCurrencyTest, log, userRights } = useSelector((state) => state);
  const [minimize, setMinimize] = useState(false);
  const [check, setCheck] = useState(false);
  const [adminCurrencyName, setAdminCurrencyName] = useState("");
  const [disable, setDisable] = useState(false);
  const [formState, setFormState] = useState("view");

  useEffect(() => {
    dispatch(getAdminCurrency(token, menuId));
    dispatch(getLog(token, { admin_currency: "admin_currency" }));
  }, [token]);

  useLayoutEffect(() => {
    dispatch(getRights(token, menuId)).then((res) => {
      if (res.type === "GET_USER_RIGHTS_SUCCESS") {
        if (!res?.payload.can_add) {
          setFormState("table");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (adminCurrencyObj) {
      setFormState("view");
      form.setFieldsValue({
        id: adminCurrencyObj.currency_id,
        adminCurrency: adminCurrencyObj.currency_name,
        active: adminCurrencyObj.is_active,
      });
      setAdminCurrencyName(adminCurrencyObj.currency_name);
      setCheck(adminCurrencyObj.is_active);
    }
  }, [adminCurrencyObj]);

  useEffect(() => {
    if (adminCurrencyName === "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [adminCurrencyName]);


  const formSave = () => {
    if (formState === "add") {
      dispatch(addAdminCurrency(token, { adminCurrencyName, check }, menuId)).then(
        (res) => {

          if (res.type === "ADD_ADMIN_CURRENCY_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          if (res.type === "ADD_ADMIN_CURRENCY_SUCCESS") {
            notification(
              "success",
              "Admin Currency Created",
              "Admin Currency Created Successfully!"
            );
            form.setFieldsValue({
              adminCurrency: "",
            });
            setFormState("");
            setAdminCurrencyName("");
            setAdminCurrencyObj(null);
          }
          dispatch(getAdminCurrency(token, menuId));
        }
      );
    }

    if (formState === "edit") {
      dispatch(
        updateAdminCurrency(
          token,
          { adminCurrencyName, check },
          adminCurrencyObj.currency_id
        )
      ).then((res) => {
        if (res.type === "UPDATE_ADMIN_CURRENCY_ERROR") {
          notification("error", "Update", "Something went wrong");
        }
        if (res.type === "UPDATE_ADMIN_CURRENCY_SUCCESS") {
          notification(
            "success",
            "Admin Currency Updated",
            "Record Updated Successfully"
          );
        }
        dispatch(getAdminCurrency(token, menuId));
      });
    }
  };

  const handleDelete = () => {
    if (adminCurrencyObj) {
      dispatch(deleteAdminCurrency(token, adminCurrencyObj.currency_id)).then(
        (res) => {
          if (res.type === "DELETE_ADMIN_CURRENCY_SUCCESS") {
            notification(
              "success",
              "Admin Currency Deleted",
              "Admin Currency Deleted Successfully!"
            );
          }
          if (res.type === "DELETE_ADMIN_CURRENCY_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          form.setFieldsValue({
            adminCurrency: "",
          });
          setAdminCurrencyName("");
          setAdminCurrencyObj(null);
          setFormState("");
          dispatch(getAdminCurrency(token, menuId));
        }
      );
    }
  };

  useEffect(() => {
    if (formState === "add") {
      dispatch(getOneDefaultCompany(token, dCompanyId));
      adminCurrencyNameInput.current.focus();
      form.setFieldsValue({
        adminCurrency: "",
      });
      setCheck(true);
      setAdminCurrencyName("");
    }
  }, [formState]);

  const filterReset = () => {
    setFormState("view");
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Currency"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="crudDiv">
              <CrudButtons
                rights={userRights?.payload}
                reset={filterReset}
                formType={formState}
                save={formSave}
                disable={disable}
                formState={setFormState}
                onDelete={handleDelete}
              />
            </div>

            <div className="styleContent">
              <Row className="tables-main-row-new">
                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                  <div className="styleTable">
                    <Tables
                      type="adminCurrency"
                      adminCurrencyObj={setAdminCurrencyObj}
                      scrollX={"20rem"}
                      scroll={602}
                      perPage={25}
                      source={adminCurrencyTest?.payload?.data}
                      col={adminCurrencyColumns}
                      paginate
                      load={adminCurrencyTest.loading}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                  <div className="styleForm">
                    <Form form={form} name="basic" labelCol={{ span: 8 }}>
                      <div className="customRow styleFormUpper ">
                        {adminCurrencyObj !== null && !(formState === "add") && (
                          <div className="customCols slc">
                            <Form.Item
                              label="ID"
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 14 }}
                              name="id"
                              initialValue={form.getFieldValue().id}
                            >
                              <Input
                                className="styleInput id-field-style"
                                readOnly
                              />
                            </Form.Item>
                          </div>
                        )}
                        <div className="customCols slc">
                          <Form.Item
                            label="Currency Name"
                            name="adminCurrency"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValue={form.getFieldValue().adminCurrency}
                          >
                            <Input
                              size="small"
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              ref={adminCurrencyNameInput}
                              onChange={(e) =>
                                setAdminCurrencyName(e.target.value)
                              }
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Active"
                            name="active"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <Checkbox
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              checked={check}
                              onChange={(e) => setCheck(e.target.checked)}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Form>

                    <Divider />
                    <div className="styleTab">
                      <Tabs
                        type="card"
                        tabBarGutter={2}
                        defaultActiveKey="1"
                        centered
                      >
                        <TabPane tab="Log Info" key="1">
                          <div className="tabs">
                            <Tables
                              type="company"
                              scrollX={"50rem"}
                              scroll={360}
                              perPage={15}
                              source={log?.payload?.data}
                              col={logColumns}
                              load={log.loading}
                              paginate
                            />
                          </div>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
      {minimize && (
        <div className="styleFooter">
          <Button
            className="minimize-button-style"
            onClick={() => setMinimize(false)}
          >
            Style
          </Button>
        </div>
      )}
    </div>
  );
}
